import template from './template.twig';

const { Component } = Shopware;

Component.override('sw-data-grid-inline-edit', {
    template,
});
